// extracted by mini-css-extract-plugin
module.exports = {"buttons":"RuleForm_buttons__2zQss","submitButton":"RuleForm_submitButton__2VXaE","smallText":"RuleForm_smallText__nRIA3","preserveWhitespace":"RuleForm_preserveWhitespace__38K5s"};